// this code was generated by /data/generate-comparisons.py

export const comparison = [
    {
        id: 1, 
        category: "work-int", 
        average: {
            max: 40.4, 
            min: 40.1
        }, 
        data: [
            {
                soc: 111, 
                max: 43.5, 
                min: 40.7
            }, 
            {
                soc: 112, 
                max: 38.7, 
                min: 37.4
            }, 
            {
                soc: 113, 
                max: 39.2, 
                min: 38.0
            }, 
            {
                soc: 114, 
                max: 51.8, 
                min: 24.7
            }, 
            {
                soc: 115, 
                max: 36.5, 
                min: 33.4
            }, 
            {
                soc: 116, 
                max: 38.7, 
                min: 35.8
            }, 
            {
                soc: 117, 
                max: 37.1, 
                min: 33.6
            }, 
            {
                soc: 121, 
                max: 45.1, 
                min: 38.0
            }, 
            {
                soc: 122, 
                max: 38.9, 
                min: 35.9
            }, 
            {
                soc: 123, 
                max: 45.2, 
                min: 40.5
            }, 
            {
                soc: 124, 
                max: 36.5, 
                min: 34.2
            }, 
            {
                soc: 125, 
                max: 44.1, 
                min: 41.3
            }, 
            {
                soc: 211, 
                max: 45.0, 
                min: 43.2
            }, 
            {
                soc: 212, 
                max: 46.3, 
                min: 44.1
            }, 
            {
                soc: 213, 
                max: 48.3, 
                min: 47.1
            }, 
            {
                soc: 214, 
                max: 41.6, 
                min: 38.2
            }, 
            {
                soc: 215, 
                max: 47.3, 
                min: 43.4
            }, 
            {
                soc: 216, 
                max: 45.2, 
                min: 41.8
            }, 
            {
                soc: 221, 
                max: 33.3, 
                min: 31.6
            }, 
            {
                soc: 222, 
                max: 47.1, 
                min: 44.8
            }, 
            {
                soc: 223, 
                max: 33.3, 
                min: 32.0
            }, 
            {
                soc: 224, 
                max: 34.0, 
                min: 30.8
            }, 
            {
                soc: 225, 
                max: 36.0, 
                min: 34.3
            }, 
            {
                soc: 231, 
                max: 31.0, 
                min: 30.3
            }, 
            {
                soc: 232, 
                max: 37.7, 
                min: 35.3
            }, 
            {
                soc: 241, 
                max: 33.5, 
                min: 31.6
            }, 
            {
                soc: 242, 
                max: 42.8, 
                min: 40.6
            }, 
            {
                soc: 243, 
                max: 45.8, 
                min: 44.3
            }, 
            {
                soc: 244, 
                max: 40.2, 
                min: 38.4
            }, 
            {
                soc: 245, 
                max: 40.7, 
                min: 38.2
            }, 
            {
                soc: 246, 
                max: 34.3, 
                min: 32.1
            }, 
            {
                soc: 247, 
                max: 57.0, 
                min: 53.1
            }, 
            {
                soc: 248, 
                max: 48.9, 
                min: 46.1
            }, 
            {
                soc: 249, 
                max: 38.0, 
                min: 35.6
            }, 
            {
                soc: 311, 
                max: 46.9, 
                min: 44.7
            }, 
            {
                soc: 312, 
                max: 45.2, 
                min: 41.0
            }, 
            {
                soc: 313, 
                max: 46.8, 
                min: 44.0
            }, 
            {
                soc: 321, 
                max: 40.0, 
                min: 35.9
            }, 
            {
                soc: 322, 
                max: 47.6, 
                min: 45.6
            }, 
            {
                soc: 323, 
                max: 48.2, 
                min: 41.2
            }, 
            {
                soc: 324, 
                max: 35.4, 
                min: 31.1
            }, 
            {
                soc: 331, 
                max: 33.5, 
                min: 32.0
            }, 
            {
                soc: 341, 
                max: 44.1, 
                min: 41.9
            }, 
            {
                soc: 342, 
                max: 43.0, 
                min: 38.2
            }, 
            {
                soc: 343, 
                max: 58.2, 
                min: 53.9
            }, 
            {
                soc: 351, 
                max: 40.5, 
                min: 36.9
            }, 
            {
                soc: 352, 
                max: 39.6, 
                min: 33.5
            }, 
            {
                soc: 353, 
                max: 41.2, 
                min: 39.0
            }, 
            {
                soc: 354, 
                max: 46.7, 
                min: 44.6
            }, 
            {
                soc: 355, 
                max: 42.8, 
                min: 41.6
            }, 
            {
                soc: 356, 
                max: 42.1, 
                min: 38.3
            }, 
            {
                soc: 357, 
                max: 43.2, 
                min: 41.4
            }, 
            {
                soc: 358, 
                max: 51.5, 
                min: 47.9
            }, 
            {
                soc: 411, 
                max: 45.6, 
                min: 43.6
            }, 
            {
                soc: 412, 
                max: 41.3, 
                min: 39.8
            }, 
            {
                soc: 413, 
                max: 43.1, 
                min: 40.9
            }, 
            {
                soc: 414, 
                max: 40.7, 
                min: 38.8
            }, 
            {
                soc: 415, 
                max: 45.9, 
                min: 44.4
            }, 
            {
                soc: 421, 
                max: 43.1, 
                min: 41.1
            }, 
            {
                soc: 511, 
                max: 59.4, 
                min: 55.3
            }, 
            {
                soc: 521, 
                max: 51.1, 
                min: 43.3
            }, 
            {
                soc: 522, 
                max: 47.5, 
                min: 44.6
            }, 
            {
                soc: 523, 
                max: 42.6, 
                min: 38.9
            }, 
            {
                soc: 524, 
                max: 47.2, 
                min: 44.4
            }, 
            {
                soc: 525, 
                max: 40.4, 
                min: 33.4
            }, 
            {
                soc: 531, 
                max: 42.2, 
                min: 38.6
            }, 
            {
                soc: 532, 
                max: 40.6, 
                min: 31.1
            }, 
            {
                soc: 533, 
                max: 46.3, 
                min: 37.4
            }, 
            {
                soc: 541, 
                max: 38.1, 
                min: 28.6
            }, 
            {
                soc: 542, 
                max: 37.2, 
                min: 29.2
            }, 
            {
                soc: 543, 
                max: 26.5, 
                min: 24.3
            }, 
            {
                soc: 544, 
                max: 47.5, 
                min: 40.4
            }, 
            {
                soc: 611, 
                max: 47.7, 
                min: 45.9
            }, 
            {
                soc: 612, 
                max: 50.3, 
                min: 45.6
            }, 
            {
                soc: 613, 
                max: 40.3, 
                min: 38.7
            }, 
            {
                soc: 621, 
                max: 44.7, 
                min: 41.4
            }, 
            {
                soc: 622, 
                max: 40.4, 
                min: 34.3
            }, 
            {
                soc: 623, 
                max: 57.8, 
                min: 50.2
            }, 
            {
                soc: 624, 
                max: 41.3, 
                min: 33.4
            }, 
            {
                soc: 625, 
                max: 64.5, 
                min: 44.0
            }, 
            {
                soc: 631, 
                max: 55.9, 
                min: 46.2
            }, 
            {
                soc: 711, 
                max: 42.2, 
                min: 40.1
            }, 
            {
                soc: 712, 
                max: 45.3, 
                min: 40.3
            }, 
            {
                soc: 713, 
                max: 41.3, 
                min: 36.7
            }, 
            {
                soc: 721, 
                max: 39.1, 
                min: 37.1
            }, 
            {
                soc: 722, 
                max: 37.4, 
                min: 32.2
            }, 
            {
                soc: 811, 
                max: 41.2, 
                min: 36.1
            }, 
            {
                soc: 812, 
                max: 45.8, 
                min: 40.7
            }, 
            {
                soc: 813, 
                max: 46.5, 
                min: 40.4
            }, 
            {
                soc: 814, 
                max: 43.2, 
                min: 39.4
            }, 
            {
                soc: 815, 
                max: 50.1, 
                min: 42.3
            }, 
            {
                soc: 816, 
                max: 40.5, 
                min: 26.4
            }, 
            {
                soc: 821, 
                max: 45.0, 
                min: 42.2
            }, 
            {
                soc: 822, 
                max: 45.1, 
                min: 37.9
            }, 
            {
                soc: 823, 
                max: 43.0, 
                min: 39.1
            }, 
            {
                soc: 911, 
                max: 49.4, 
                min: 42.4
            }, 
            {
                soc: 912, 
                max: 51.5, 
                min: 43.0
            }, 
            {
                soc: 913, 
                max: 38.7, 
                min: 34.2
            }, 
            {
                soc: 921, 
                max: 36.5, 
                min: 32.6
            }, 
            {
                soc: 922, 
                max: 46.0, 
                min: 41.6
            }, 
            {
                soc: 923, 
                max: 61.9, 
                min: 57.2
            }, 
            {
                soc: 924, 
                max: 27.4, 
                min: 17.8
            }, 
            {
                soc: 925, 
                max: 37.3, 
                min: 33.8
            }, 
            {
                soc: 926, 
                max: 36.9, 
                min: 34.8
            }
        ]
    }, 
    {
        id: 2, 
        category: "task-disc", 
        average: {
            max: 69.9, 
            min: 69.6
        }, 
        data: [
            {
                soc: 111, 
                max: 93.3, 
                min: 91.2
            }, 
            {
                soc: 112, 
                max: 85.0, 
                min: 83.9
            }, 
            {
                soc: 113, 
                max: 85.6, 
                min: 84.5
            }, 
            {
                soc: 114, 
                max: 95.1, 
                min: 62.4
            }, 
            {
                soc: 115, 
                max: 79.3, 
                min: 76.4
            }, 
            {
                soc: 116, 
                max: 68.0, 
                min: 64.3
            }, 
            {
                soc: 117, 
                max: 81.3, 
                min: 78.0
            }, 
            {
                soc: 121, 
                max: 86.2, 
                min: 79.6
            }, 
            {
                soc: 122, 
                max: 81.3, 
                min: 78.2
            }, 
            {
                soc: 123, 
                max: 85.6, 
                min: 81.6
            }, 
            {
                soc: 124, 
                max: 78.8, 
                min: 76.3
            }, 
            {
                soc: 125, 
                max: 84.2, 
                min: 81.7
            }, 
            {
                soc: 211, 
                max: 72.6, 
                min: 70.5
            }, 
            {
                soc: 212, 
                max: 75.5, 
                min: 73.2
            }, 
            {
                soc: 213, 
                max: 78.1, 
                min: 76.9
            }, 
            {
                soc: 214, 
                max: 68.8, 
                min: 65.0
            }, 
            {
                soc: 215, 
                max: 77.0, 
                min: 73.1
            }, 
            {
                soc: 216, 
                max: 84.3, 
                min: 81.3
            }, 
            {
                soc: 221, 
                max: 67.6, 
                min: 65.6
            }, 
            {
                soc: 222, 
                max: 79.6, 
                min: 77.6
            }, 
            {
                soc: 223, 
                max: 67.7, 
                min: 66.2
            }, 
            {
                soc: 224, 
                max: 70.7, 
                min: 67.3
            }, 
            {
                soc: 225, 
                max: 70.4, 
                min: 68.4
            }, 
            {
                soc: 231, 
                max: 72.1, 
                min: 71.4
            }, 
            {
                soc: 232, 
                max: 82.3, 
                min: 79.9
            }, 
            {
                soc: 241, 
                max: 74.6, 
                min: 72.4
            }, 
            {
                soc: 242, 
                max: 74.1, 
                min: 71.7
            }, 
            {
                soc: 243, 
                max: 78.8, 
                min: 77.4
            }, 
            {
                soc: 244, 
                max: 80.7, 
                min: 79.0
            }, 
            {
                soc: 245, 
                max: 76.3, 
                min: 73.5
            }, 
            {
                soc: 246, 
                max: 74.8, 
                min: 72.6
            }, 
            {
                soc: 247, 
                max: 84.0, 
                min: 80.2
            }, 
            {
                soc: 248, 
                max: 79.9, 
                min: 77.1
            }, 
            {
                soc: 249, 
                max: 76.3, 
                min: 73.7
            }, 
            {
                soc: 311, 
                max: 67.5, 
                min: 65.0
            }, 
            {
                soc: 312, 
                max: 68.1, 
                min: 63.1
            }, 
            {
                soc: 313, 
                max: 71.4, 
                min: 68.5
            }, 
            {
                soc: 321, 
                max: 68.9, 
                min: 64.8
            }, 
            {
                soc: 322, 
                max: 74.3, 
                min: 72.2
            }, 
            {
                soc: 323, 
                max: 75.8, 
                min: 68.6
            }, 
            {
                soc: 324, 
                max: 67.3, 
                min: 62.2
            }, 
            {
                soc: 331, 
                max: 58.8, 
                min: 57.1
            }, 
            {
                soc: 341, 
                max: 76.0, 
                min: 73.7
            }, 
            {
                soc: 342, 
                max: 78.5, 
                min: 73.7
            }, 
            {
                soc: 343, 
                max: 83.2, 
                min: 78.8
            }, 
            {
                soc: 351, 
                max: 68.3, 
                min: 64.0
            }, 
            {
                soc: 352, 
                max: 76.2, 
                min: 69.3
            }, 
            {
                soc: 353, 
                max: 77.1, 
                min: 74.7
            }, 
            {
                soc: 354, 
                max: 72.1, 
                min: 69.8
            }, 
            {
                soc: 355, 
                max: 77.8, 
                min: 76.6
            }, 
            {
                soc: 356, 
                max: 74.6, 
                min: 70.6
            }, 
            {
                soc: 357, 
                max: 75.1, 
                min: 73.3
            }, 
            {
                soc: 358, 
                max: 80.6, 
                min: 76.8
            }, 
            {
                soc: 411, 
                max: 68.1, 
                min: 65.8
            }, 
            {
                soc: 412, 
                max: 65.5, 
                min: 63.7
            }, 
            {
                soc: 413, 
                max: 65.7, 
                min: 63.3
            }, 
            {
                soc: 414, 
                max: 81.3, 
                min: 79.5
            }, 
            {
                soc: 415, 
                max: 62.4, 
                min: 60.6
            }, 
            {
                soc: 421, 
                max: 64.7, 
                min: 62.4
            }, 
            {
                soc: 511, 
                max: 80.0, 
                min: 75.9
            }, 
            {
                soc: 521, 
                max: 64.7, 
                min: 56.4
            }, 
            {
                soc: 522, 
                max: 69.8, 
                min: 66.5
            }, 
            {
                soc: 523, 
                max: 68.5, 
                min: 64.7
            }, 
            {
                soc: 524, 
                max: 71.5, 
                min: 68.5
            }, 
            {
                soc: 525, 
                max: 87.7, 
                min: 82.0
            }, 
            {
                soc: 531, 
                max: 75.6, 
                min: 72.0
            }, 
            {
                soc: 532, 
                max: 86.6, 
                min: 76.9
            }, 
            {
                soc: 533, 
                max: 80.2, 
                min: 71.5
            }, 
            {
                soc: 541, 
                max: 69.6, 
                min: 57.3
            }, 
            {
                soc: 542, 
                max: 71.0, 
                min: 61.8
            }, 
            {
                soc: 543, 
                max: 78.2, 
                min: 75.5
            }, 
            {
                soc: 544, 
                max: 77.5, 
                min: 70.8
            }, 
            {
                soc: 611, 
                max: 63.0, 
                min: 61.3
            }, 
            {
                soc: 612, 
                max: 75.6, 
                min: 70.9
            }, 
            {
                soc: 613, 
                max: 63.7, 
                min: 62.0
            }, 
            {
                soc: 621, 
                max: 60.3, 
                min: 56.5
            }, 
            {
                soc: 622, 
                max: 79.3, 
                min: 71.7
            }, 
            {
                soc: 623, 
                max: 70.7, 
                min: 63.5
            }, 
            {
                soc: 624, 
                max: 84.6, 
                min: 77.5
            }, 
            {
                soc: 625, 
                max: 100.4, 
                min: 90.2
            }, 
            {
                soc: 631, 
                max: 66.1, 
                min: 54.9
            }, 
            {
                soc: 711, 
                max: 55.7, 
                min: 53.4
            }, 
            {
                soc: 712, 
                max: 66.6, 
                min: 60.1
            }, 
            {
                soc: 713, 
                max: 77.4, 
                min: 72.7
            }, 
            {
                soc: 721, 
                max: 49.9, 
                min: 47.6
            }, 
            {
                soc: 722, 
                max: 72.1, 
                min: 65.1
            }, 
            {
                soc: 811, 
                max: 60.7, 
                min: 54.7
            }, 
            {
                soc: 812, 
                max: 74.4, 
                min: 68.6
            }, 
            {
                soc: 813, 
                max: 63.5, 
                min: 57.0
            }, 
            {
                soc: 814, 
                max: 61.9, 
                min: 57.3
            }, 
            {
                soc: 815, 
                max: 71.1, 
                min: 62.4
            }, 
            {
                soc: 816, 
                max: 76.4, 
                min: 61.9
            }, 
            {
                soc: 821, 
                max: 53.8, 
                min: 50.6
            }, 
            {
                soc: 822, 
                max: 61.3, 
                min: 52.8
            }, 
            {
                soc: 823, 
                max: 52.9, 
                min: 48.4
            }, 
            {
                soc: 911, 
                max: 60.8, 
                min: 52.8
            }, 
            {
                soc: 912, 
                max: 64.5, 
                min: 54.3
            }, 
            {
                soc: 913, 
                max: 48.8, 
                min: 43.0
            }, 
            {
                soc: 921, 
                max: 53.2, 
                min: 48.9
            }, 
            {
                soc: 922, 
                max: 65.7, 
                min: 60.9
            }, 
            {
                soc: 923, 
                max: 56.9, 
                min: 51.4
            }, 
            {
                soc: 924, 
                max: 53.3, 
                min: 39.9
            }, 
            {
                soc: 925, 
                max: 54.5, 
                min: 50.2
            }, 
            {
                soc: 926, 
                max: 58.2, 
                min: 55.7
            }
        ]
    }, 
    {
        id: 3, 
        category: "worker-voi", 
        average: {
            max: 38.2, 
            min: 37.8
        }, 
        data: [
            {
                soc: 111, 
                max: 83.3, 
                min: 79.5
            }, 
            {
                soc: 112, 
                max: 60.6, 
                min: 58.7
            }, 
            {
                soc: 113, 
                max: 59.2, 
                min: 57.2
            }, 
            {
                soc: 114, 
                max: 84.5, 
                min: 49.3
            }, 
            {
                soc: 115, 
                max: 38.2, 
                min: 33.9
            }, 
            {
                soc: 116, 
                max: 39.5, 
                min: 34.9
            }, 
            {
                soc: 117, 
                max: 53.4, 
                min: 48.2
            }, 
            {
                soc: 121, 
                max: 67.0, 
                min: 56.9
            }, 
            {
                soc: 122, 
                max: 54.2, 
                min: 49.2
            }, 
            {
                soc: 123, 
                max: 62.8, 
                min: 56.2
            }, 
            {
                soc: 124, 
                max: 41.3, 
                min: 37.9
            }, 
            {
                soc: 125, 
                max: 55.6, 
                min: 51.2
            }, 
            {
                soc: 211, 
                max: 40.5, 
                min: 38.0
            }, 
            {
                soc: 212, 
                max: 44.5, 
                min: 41.2
            }, 
            {
                soc: 213, 
                max: 46.2, 
                min: 44.4
            }, 
            {
                soc: 214, 
                max: 43.0, 
                min: 37.8
            }, 
            {
                soc: 215, 
                max: 47.5, 
                min: 41.7
            }, 
            {
                soc: 216, 
                max: 46.9, 
                min: 42.3
            }, 
            {
                soc: 221, 
                max: 39.3, 
                min: 36.6
            }, 
            {
                soc: 222, 
                max: 47.2, 
                min: 44.0
            }, 
            {
                soc: 223, 
                max: 32.4, 
                min: 30.8
            }, 
            {
                soc: 224, 
                max: 47.1, 
                min: 41.7
            }, 
            {
                soc: 225, 
                max: 39.8, 
                min: 37.3
            }, 
            {
                soc: 231, 
                max: 32.8, 
                min: 31.9
            }, 
            {
                soc: 232, 
                max: 59.2, 
                min: 55.2
            }, 
            {
                soc: 241, 
                max: 41.6, 
                min: 38.5
            }, 
            {
                soc: 242, 
                max: 45.2, 
                min: 41.7
            }, 
            {
                soc: 243, 
                max: 46.1, 
                min: 43.8
            }, 
            {
                soc: 244, 
                max: 47.6, 
                min: 44.8
            }, 
            {
                soc: 245, 
                max: 47.3, 
                min: 43.3
            }, 
            {
                soc: 246, 
                max: 38.8, 
                min: 35.6
            }, 
            {
                soc: 247, 
                max: 43.1, 
                min: 37.6
            }, 
            {
                soc: 248, 
                max: 47.6, 
                min: 43.5
            }, 
            {
                soc: 249, 
                max: 40.3, 
                min: 36.6
            }, 
            {
                soc: 311, 
                max: 35.3, 
                min: 32.4
            }, 
            {
                soc: 312, 
                max: 42.8, 
                min: 36.5
            }, 
            {
                soc: 313, 
                max: 37.1, 
                min: 33.6
            }, 
            {
                soc: 321, 
                max: 44.0, 
                min: 38.9
            }, 
            {
                soc: 322, 
                max: 39.4, 
                min: 36.8
            }, 
            {
                soc: 323, 
                max: 44.5, 
                min: 35.7
            }, 
            {
                soc: 324, 
                max: 37.3, 
                min: 30.8
            }, 
            {
                soc: 331, 
                max: 18.1, 
                min: 16.5
            }, 
            {
                soc: 341, 
                max: 52.5, 
                min: 49.0
            }, 
            {
                soc: 342, 
                max: 50.6, 
                min: 43.2
            }, 
            {
                soc: 343, 
                max: 53.7, 
                min: 46.9
            }, 
            {
                soc: 351, 
                max: 36.1, 
                min: 31.0
            }, 
            {
                soc: 352, 
                max: 45.2, 
                min: 37.0
            }, 
            {
                soc: 353, 
                max: 42.8, 
                min: 39.5
            }, 
            {
                soc: 354, 
                max: 39.8, 
                min: 36.9
            }, 
            {
                soc: 355, 
                max: 40.2, 
                min: 38.5
            }, 
            {
                soc: 356, 
                max: 41.2, 
                min: 35.8
            }, 
            {
                soc: 357, 
                max: 40.7, 
                min: 38.3
            }, 
            {
                soc: 358, 
                max: 51.1, 
                min: 45.3
            }, 
            {
                soc: 411, 
                max: 34.2, 
                min: 31.5
            }, 
            {
                soc: 412, 
                max: 33.7, 
                min: 31.7
            }, 
            {
                soc: 413, 
                max: 31.3, 
                min: 28.8
            }, 
            {
                soc: 414, 
                max: 52.8, 
                min: 50.0
            }, 
            {
                soc: 415, 
                max: 31.5, 
                min: 29.7
            }, 
            {
                soc: 421, 
                max: 35.8, 
                min: 33.3
            }, 
            {
                soc: 511, 
                max: 56.5, 
                min: 50.3
            }, 
            {
                soc: 521, 
                max: 38.7, 
                min: 29.5
            }, 
            {
                soc: 522, 
                max: 36.4, 
                min: 32.6
            }, 
            {
                soc: 523, 
                max: 34.2, 
                min: 29.4
            }, 
            {
                soc: 524, 
                max: 36.3, 
                min: 32.5
            }, 
            {
                soc: 525, 
                max: 56.8, 
                min: 45.1
            }, 
            {
                soc: 531, 
                max: 49.8, 
                min: 44.5
            }, 
            {
                soc: 532, 
                max: 75.2, 
                min: 60.5
            }, 
            {
                soc: 533, 
                max: 48.8, 
                min: 37.3
            }, 
            {
                soc: 541, 
                max: 45.6, 
                min: 30.2
            }, 
            {
                soc: 542, 
                max: 31.0, 
                min: 21.1
            }, 
            {
                soc: 543, 
                max: 41.5, 
                min: 37.9
            }, 
            {
                soc: 544, 
                max: 48.9, 
                min: 37.7
            }, 
            {
                soc: 611, 
                max: 27.5, 
                min: 25.6
            }, 
            {
                soc: 612, 
                max: 56.7, 
                min: 49.8
            }, 
            {
                soc: 613, 
                max: 30.6, 
                min: 28.8
            }, 
            {
                soc: 621, 
                max: 27.9, 
                min: 24.3
            }, 
            {
                soc: 622, 
                max: 55.0, 
                min: 45.2
            }, 
            {
                soc: 623, 
                max: 39.3, 
                min: 29.3
            }, 
            {
                soc: 624, 
                max: 54.6, 
                min: 44.9
            }, 
            {
                soc: 625, 
                max: 96.7, 
                min: 70.2
            }, 
            {
                soc: 631, 
                max: 23.8, 
                min: 15.0
            }, 
            {
                soc: 711, 
                max: 22.1, 
                min: 20.0
            }, 
            {
                soc: 712, 
                max: 36.2, 
                min: 29.4
            }, 
            {
                soc: 713, 
                max: 39.3, 
                min: 32.8
            }, 
            {
                soc: 721, 
                max: 21.9, 
                min: 19.9
            }, 
            {
                soc: 722, 
                max: 33.3, 
                min: 25.4
            }, 
            {
                soc: 811, 
                max: 33.6, 
                min: 27.0
            }, 
            {
                soc: 812, 
                max: 43.5, 
                min: 35.9
            }, 
            {
                soc: 813, 
                max: 29.4, 
                min: 22.0
            }, 
            {
                soc: 814, 
                max: 33.9, 
                min: 29.0
            }, 
            {
                soc: 815, 
                max: 44.8, 
                min: 34.2
            }, 
            {
                soc: 816, 
                max: 49.5, 
                min: 30.7
            }, 
            {
                soc: 821, 
                max: 26.8, 
                min: 23.8
            }, 
            {
                soc: 822, 
                max: 39.0, 
                min: 28.4
            }, 
            {
                soc: 823, 
                max: 35.7, 
                min: 30.8
            }, 
            {
                soc: 911, 
                max: 36.4, 
                min: 27.7
            }, 
            {
                soc: 912, 
                max: 43.1, 
                min: 30.3
            }, 
            {
                soc: 913, 
                max: 24.0, 
                min: 19.2
            }, 
            {
                soc: 921, 
                max: 24.2, 
                min: 19.8
            }, 
            {
                soc: 922, 
                max: 40.8, 
                min: 35.2
            }, 
            {
                soc: 923, 
                max: 24.2, 
                min: 19.5
            }, 
            {
                soc: 924, 
                max: 22.4, 
                min: 11.2
            }, 
            {
                soc: 925, 
                max: 22.8, 
                min: 19.3
            }, 
            {
                soc: 926, 
                max: 25.2, 
                min: 22.8
            }
        ]
    }, 
    {
        id: 4, 
        category: "autonomy-ove", 
        average: {
            max: 43.0, 
            min: 42.6
        }, 
        data: [
            {
                soc: 111, 
                max: 81.5, 
                min: 78.2
            }, 
            {
                soc: 112, 
                max: 61.3, 
                min: 59.4
            }, 
            {
                soc: 113, 
                max: 66.0, 
                min: 64.2
            }, 
            {
                soc: 114, 
                max: 92.6, 
                min: 58.7
            }, 
            {
                soc: 115, 
                max: 35.3, 
                min: 31.2
            }, 
            {
                soc: 116, 
                max: 43.6, 
                min: 38.3
            }, 
            {
                soc: 117, 
                max: 63.7, 
                min: 58.3
            }, 
            {
                soc: 121, 
                max: 50.7, 
                min: 39.9
            }, 
            {
                soc: 122, 
                max: 50.8, 
                min: 45.9
            }, 
            {
                soc: 123, 
                max: 58.8, 
                min: 52.4
            }, 
            {
                soc: 124, 
                max: 49.6, 
                min: 45.9
            }, 
            {
                soc: 125, 
                max: 57.1, 
                min: 52.7
            }, 
            {
                soc: 211, 
                max: 61.4, 
                min: 58.4
            }, 
            {
                soc: 212, 
                max: 63.9, 
                min: 60.5
            }, 
            {
                soc: 213, 
                max: 66.0, 
                min: 64.2
            }, 
            {
                soc: 214, 
                max: 54.2, 
                min: 48.8
            }, 
            {
                soc: 215, 
                max: 70.1, 
                min: 64.5
            }, 
            {
                soc: 216, 
                max: 76.3, 
                min: 72.1
            }, 
            {
                soc: 221, 
                max: 34.6, 
                min: 31.7
            }, 
            {
                soc: 222, 
                max: 52.8, 
                min: 49.4
            }, 
            {
                soc: 223, 
                max: 24.6, 
                min: 22.9
            }, 
            {
                soc: 224, 
                max: 16.8, 
                min: 12.6
            }, 
            {
                soc: 225, 
                max: 27.1, 
                min: 24.5
            }, 
            {
                soc: 231, 
                max: 32.0, 
                min: 31.0
            }, 
            {
                soc: 232, 
                max: 54.2, 
                min: 50.5
            }, 
            {
                soc: 241, 
                max: 56.5, 
                min: 53.4
            }, 
            {
                soc: 242, 
                max: 62.6, 
                min: 59.2
            }, 
            {
                soc: 243, 
                max: 71.0, 
                min: 69.0
            }, 
            {
                soc: 244, 
                max: 69.8, 
                min: 67.4
            }, 
            {
                soc: 245, 
                max: 60.7, 
                min: 57.0
            }, 
            {
                soc: 246, 
                max: 58.4, 
                min: 55.3
            }, 
            {
                soc: 247, 
                max: 57.6, 
                min: 51.5
            }, 
            {
                soc: 248, 
                max: 65.2, 
                min: 61.2
            }, 
            {
                soc: 249, 
                max: 56.6, 
                min: 52.8
            }, 
            {
                soc: 311, 
                max: 43.5, 
                min: 40.3
            }, 
            {
                soc: 312, 
                max: 50.4, 
                min: 43.7
            }, 
            {
                soc: 313, 
                max: 52.7, 
                min: 48.5
            }, 
            {
                soc: 321, 
                max: 34.2, 
                min: 28.8
            }, 
            {
                soc: 322, 
                max: 53.3, 
                min: 50.4
            }, 
            {
                soc: 323, 
                max: 26.8, 
                min: 17.7
            }, 
            {
                soc: 324, 
                max: 15.0, 
                min: 10.7
            }, 
            {
                soc: 331, 
                max: 17.5, 
                min: 15.7
            }, 
            {
                soc: 341, 
                max: 57.1, 
                min: 53.7
            }, 
            {
                soc: 342, 
                max: 54.9, 
                min: 47.6
            }, 
            {
                soc: 343, 
                max: 51.4, 
                min: 44.5
            }, 
            {
                soc: 351, 
                max: 19.0, 
                min: 14.5
            }, 
            {
                soc: 352, 
                max: 49.4, 
                min: 40.2
            }, 
            {
                soc: 353, 
                max: 53.1, 
                min: 49.8
            }, 
            {
                soc: 354, 
                max: 61.7, 
                min: 58.5
            }, 
            {
                soc: 355, 
                max: 54.5, 
                min: 52.7
            }, 
            {
                soc: 356, 
                max: 46.1, 
                min: 39.6
            }, 
            {
                soc: 357, 
                max: 54.2, 
                min: 51.5
            }, 
            {
                soc: 358, 
                max: 68.2, 
                min: 62.9
            }, 
            {
                soc: 411, 
                max: 69.2, 
                min: 66.2
            }, 
            {
                soc: 412, 
                max: 45.2, 
                min: 43.0
            }, 
            {
                soc: 413, 
                max: 38.1, 
                min: 35.1
            }, 
            {
                soc: 414, 
                max: 50.7, 
                min: 47.9
            }, 
            {
                soc: 415, 
                max: 41.1, 
                min: 39.0
            }, 
            {
                soc: 421, 
                max: 35.5, 
                min: 32.8
            }, 
            {
                soc: 511, 
                max: 52.6, 
                min: 46.4
            }, 
            {
                soc: 521, 
                max: 40.6, 
                min: 30.0
            }, 
            {
                soc: 522, 
                max: 40.6, 
                min: 36.2
            }, 
            {
                soc: 523, 
                max: 32.2, 
                min: 27.1
            }, 
            {
                soc: 524, 
                max: 48.9, 
                min: 44.7
            }, 
            {
                soc: 525, 
                max: 46.7, 
                min: 37.0
            }, 
            {
                soc: 531, 
                max: 57.6, 
                min: 52.3
            }, 
            {
                soc: 532, 
                max: 75.9, 
                min: 61.8
            }, 
            {
                soc: 533, 
                max: 50.7, 
                min: 34.9
            }, 
            {
                soc: 541, 
                max: 38.3, 
                min: 23.2
            }, 
            {
                soc: 542, 
                max: 30.5, 
                min: 20.3
            }, 
            {
                soc: 543, 
                max: 33.0, 
                min: 29.6
            }, 
            {
                soc: 544, 
                max: 52.9, 
                min: 42.1
            }, 
            {
                soc: 611, 
                max: 17.8, 
                min: 16.0
            }, 
            {
                soc: 612, 
                max: 47.1, 
                min: 40.0
            }, 
            {
                soc: 613, 
                max: 21.7, 
                min: 19.9
            }, 
            {
                soc: 621, 
                max: 21.1, 
                min: 17.4
            }, 
            {
                soc: 622, 
                max: 45.8, 
                min: 35.7
            }, 
            {
                soc: 623, 
                max: 39.0, 
                min: 30.0
            }, 
            {
                soc: 624, 
                max: 53.0, 
                min: 43.0
            }, 
            {
                soc: 625, 
                max: 89.5, 
                min: 54.9
            }, 
            {
                soc: 631, 
                max: 24.0, 
                min: 14.5
            }, 
            {
                soc: 711, 
                max: 17.9, 
                min: 16.0
            }, 
            {
                soc: 712, 
                max: 41.9, 
                min: 34.2
            }, 
            {
                soc: 713, 
                max: 32.4, 
                min: 26.1
            }, 
            {
                soc: 721, 
                max: 21.3, 
                min: 19.0
            }, 
            {
                soc: 722, 
                max: 31.4, 
                min: 22.1
            }, 
            {
                soc: 811, 
                max: 27.9, 
                min: 21.9
            }, 
            {
                soc: 812, 
                max: 60.7, 
                min: 52.6
            }, 
            {
                soc: 813, 
                max: 35.8, 
                min: 27.9
            }, 
            {
                soc: 814, 
                max: 38.0, 
                min: 32.5
            }, 
            {
                soc: 815, 
                max: 41.7, 
                min: 31.4
            }, 
            {
                soc: 816, 
                max: 30.6, 
                min: 16.2
            }, 
            {
                soc: 821, 
                max: 35.3, 
                min: 31.7
            }, 
            {
                soc: 822, 
                max: 25.2, 
                min: 17.2
            }, 
            {
                soc: 823, 
                max: 17.5, 
                min: 13.6
            }, 
            {
                soc: 911, 
                max: 39.7, 
                min: 30.5
            }, 
            {
                soc: 912, 
                max: 53.2, 
                min: 38.8
            }, 
            {
                soc: 913, 
                max: 23.5, 
                min: 17.9
            }, 
            {
                soc: 921, 
                max: 25.8, 
                min: 21.3
            }, 
            {
                soc: 922, 
                max: 41.8, 
                min: 36.1
            }, 
            {
                soc: 923, 
                max: 20.6, 
                min: 15.4
            }, 
            {
                soc: 924, 
                max: 31.0, 
                min: 15.3
            }, 
            {
                soc: 925, 
                max: 22.7, 
                min: 19.0
            }, 
            {
                soc: 926, 
                max: 20.2, 
                min: 17.9
            }
        ]
    }, 
    {
        id: 5, 
        category: "work-bal", 
        average: {
            max: 58.3, 
            min: 57.9
        }, 
        data: [
            {
                soc: 111, 
                max: 81.2, 
                min: 77.7
            }, 
            {
                soc: 112, 
                max: 71.3, 
                min: 69.6
            }, 
            {
                soc: 113, 
                max: 75.0, 
                min: 73.4
            }, 
            {
                soc: 114, 
                max: 85.0, 
                min: 55.0
            }, 
            {
                soc: 115, 
                max: 48.4, 
                min: 44.1
            }, 
            {
                soc: 116, 
                max: 58.4, 
                min: 53.2
            }, 
            {
                soc: 117, 
                max: 68.9, 
                min: 63.8
            }, 
            {
                soc: 121, 
                max: 63.5, 
                min: 53.1
            }, 
            {
                soc: 122, 
                max: 50.4, 
                min: 45.5
            }, 
            {
                soc: 123, 
                max: 69.4, 
                min: 63.5
            }, 
            {
                soc: 124, 
                max: 60.9, 
                min: 57.1
            }, 
            {
                soc: 125, 
                max: 71.4, 
                min: 67.6
            }, 
            {
                soc: 211, 
                max: 71.5, 
                min: 68.9
            }, 
            {
                soc: 212, 
                max: 76.4, 
                min: 73.3
            }, 
            {
                soc: 213, 
                max: 80.1, 
                min: 78.6
            }, 
            {
                soc: 214, 
                max: 73.6, 
                min: 69.3
            }, 
            {
                soc: 215, 
                max: 80.8, 
                min: 75.7
            }, 
            {
                soc: 216, 
                max: 81.0, 
                min: 77.0
            }, 
            {
                soc: 221, 
                max: 39.6, 
                min: 36.7
            }, 
            {
                soc: 222, 
                max: 60.4, 
                min: 57.3
            }, 
            {
                soc: 223, 
                max: 35.0, 
                min: 33.1
            }, 
            {
                soc: 224, 
                max: 32.1, 
                min: 27.0
            }, 
            {
                soc: 225, 
                max: 36.0, 
                min: 33.5
            }, 
            {
                soc: 231, 
                max: 33.0, 
                min: 31.8
            }, 
            {
                soc: 232, 
                max: 57.7, 
                min: 53.8
            }, 
            {
                soc: 241, 
                max: 66.0, 
                min: 63.1
            }, 
            {
                soc: 242, 
                max: 75.2, 
                min: 72.2
            }, 
            {
                soc: 243, 
                max: 80.0, 
                min: 78.2
            }, 
            {
                soc: 244, 
                max: 79.2, 
                min: 76.9
            }, 
            {
                soc: 245, 
                max: 76.6, 
                min: 73.3
            }, 
            {
                soc: 246, 
                max: 64.2, 
                min: 61.3
            }, 
            {
                soc: 247, 
                max: 74.5, 
                min: 69.3
            }, 
            {
                soc: 248, 
                max: 80.4, 
                min: 77.1
            }, 
            {
                soc: 249, 
                max: 72.6, 
                min: 69.2
            }, 
            {
                soc: 311, 
                max: 67.4, 
                min: 64.4
            }, 
            {
                soc: 312, 
                max: 77.6, 
                min: 72.2
            }, 
            {
                soc: 313, 
                max: 74.2, 
                min: 70.8
            }, 
            {
                soc: 321, 
                max: 54.2, 
                min: 49.2
            }, 
            {
                soc: 322, 
                max: 68.4, 
                min: 65.8
            }, 
            {
                soc: 323, 
                max: 39.6, 
                min: 30.2
            }, 
            {
                soc: 324, 
                max: 40.4, 
                min: 33.6
            }, 
            {
                soc: 331, 
                max: 40.1, 
                min: 37.8
            }, 
            {
                soc: 341, 
                max: 68.0, 
                min: 64.6
            }, 
            {
                soc: 342, 
                max: 74.5, 
                min: 68.5
            }, 
            {
                soc: 343, 
                max: 59.6, 
                min: 53.1
            }, 
            {
                soc: 351, 
                max: 26.8, 
                min: 21.8
            }, 
            {
                soc: 352, 
                max: 69.4, 
                min: 60.8
            }, 
            {
                soc: 353, 
                max: 74.6, 
                min: 71.6
            }, 
            {
                soc: 354, 
                max: 76.9, 
                min: 74.2
            }, 
            {
                soc: 355, 
                max: 72.3, 
                min: 70.7
            }, 
            {
                soc: 356, 
                max: 63.5, 
                min: 57.8
            }, 
            {
                soc: 357, 
                max: 71.5, 
                min: 69.2
            }, 
            {
                soc: 358, 
                max: 75.9, 
                min: 70.8
            }, 
            {
                soc: 411, 
                max: 76.9, 
                min: 74.4
            }, 
            {
                soc: 412, 
                max: 66.9, 
                min: 64.8
            }, 
            {
                soc: 413, 
                max: 63.4, 
                min: 60.5
            }, 
            {
                soc: 414, 
                max: 68.9, 
                min: 66.4
            }, 
            {
                soc: 415, 
                max: 65.7, 
                min: 63.6
            }, 
            {
                soc: 421, 
                max: 59.8, 
                min: 57.0
            }, 
            {
                soc: 511, 
                max: 73.2, 
                min: 67.7
            }, 
            {
                soc: 521, 
                max: 66.0, 
                min: 55.4
            }, 
            {
                soc: 522, 
                max: 66.0, 
                min: 61.9
            }, 
            {
                soc: 523, 
                max: 62.4, 
                min: 57.5
            }, 
            {
                soc: 524, 
                max: 63.6, 
                min: 59.5
            }, 
            {
                soc: 525, 
                max: 77.0, 
                min: 68.0
            }, 
            {
                soc: 531, 
                max: 72.4, 
                min: 67.8
            }, 
            {
                soc: 532, 
                max: 78.7, 
                min: 68.1
            }, 
            {
                soc: 533, 
                max: 75.9, 
                min: 62.3
            }, 
            {
                soc: 541, 
                max: 69.2, 
                min: 54.3
            }, 
            {
                soc: 542, 
                max: 61.3, 
                min: 51.0
            }, 
            {
                soc: 543, 
                max: 37.7, 
                min: 34.2
            }, 
            {
                soc: 544, 
                max: 71.8, 
                min: 62.7
            }, 
            {
                soc: 611, 
                max: 39.0, 
                min: 36.8
            }, 
            {
                soc: 612, 
                max: 59.7, 
                min: 53.7
            }, 
            {
                soc: 613, 
                max: 38.8, 
                min: 36.8
            }, 
            {
                soc: 621, 
                max: 37.5, 
                min: 33.0
            }, 
            {
                soc: 622, 
                max: 55.3, 
                min: 46.3
            }, 
            {
                soc: 623, 
                max: 64.8, 
                min: 54.9
            }, 
            {
                soc: 624, 
                max: 65.5, 
                min: 55.9
            }, 
            {
                soc: 625, 
                max: 84.2, 
                min: 45.2
            }, 
            {
                soc: 631, 
                max: 67.7, 
                min: 55.8
            }, 
            {
                soc: 711, 
                max: 43.9, 
                min: 41.4
            }, 
            {
                soc: 712, 
                max: 64.2, 
                min: 56.9
            }, 
            {
                soc: 713, 
                max: 55.9, 
                min: 49.1
            }, 
            {
                soc: 721, 
                max: 50.6, 
                min: 47.9
            }, 
            {
                soc: 722, 
                max: 62.5, 
                min: 52.7
            }, 
            {
                soc: 811, 
                max: 53.9, 
                min: 46.8
            }, 
            {
                soc: 812, 
                max: 74.5, 
                min: 67.6
            }, 
            {
                soc: 813, 
                max: 61.2, 
                min: 53.9
            }, 
            {
                soc: 814, 
                max: 62.8, 
                min: 57.5
            }, 
            {
                soc: 815, 
                max: 63.0, 
                min: 52.3
            }, 
            {
                soc: 816, 
                max: 58.2, 
                min: 39.3
            }, 
            {
                soc: 821, 
                max: 38.9, 
                min: 35.2
            }, 
            {
                soc: 822, 
                max: 53.7, 
                min: 43.5
            }, 
            {
                soc: 823, 
                max: 38.3, 
                min: 33.0
            }, 
            {
                soc: 911, 
                max: 58.6, 
                min: 49.1
            }, 
            {
                soc: 912, 
                max: 70.4, 
                min: 56.7
            }, 
            {
                soc: 913, 
                max: 51.8, 
                min: 45.5
            }, 
            {
                soc: 921, 
                max: 37.4, 
                min: 32.1
            }, 
            {
                soc: 922, 
                max: 57.6, 
                min: 52.3
            }, 
            {
                soc: 923, 
                max: 40.6, 
                min: 34.1
            }, 
            {
                soc: 924, 
                max: 49.5, 
                min: 35.6
            }, 
            {
                soc: 925, 
                max: 53.6, 
                min: 49.0
            }, 
            {
                soc: 926, 
                max: 40.7, 
                min: 37.7
            }
        ]
    }, 
    {
        id: 6, 
        category: "managerial-sup", 
        average: {
            max: 56.2, 
            min: 55.8
        }, 
        data: [
            {
                soc: 111, 
                max: 68.0, 
                min: 64.1
            }, 
            {
                soc: 112, 
                max: 60.3, 
                min: 58.7
            }, 
            {
                soc: 113, 
                max: 60.2, 
                min: 58.5
            }, 
            {
                soc: 114, 
                max: 66.8, 
                min: 39.3
            }, 
            {
                soc: 115, 
                max: 56.2, 
                min: 52.6
            }, 
            {
                soc: 116, 
                max: 65.6, 
                min: 61.8
            }, 
            {
                soc: 117, 
                max: 60.2, 
                min: 55.4
            }, 
            {
                soc: 121, 
                max: 60.8, 
                min: 51.8
            }, 
            {
                soc: 122, 
                max: 58.6, 
                min: 54.4
            }, 
            {
                soc: 123, 
                max: 61.7, 
                min: 55.6
            }, 
            {
                soc: 124, 
                max: 55.2, 
                min: 52.1
            }, 
            {
                soc: 125, 
                max: 61.5, 
                min: 57.8
            }, 
            {
                soc: 211, 
                max: 59.9, 
                min: 57.6
            }, 
            {
                soc: 212, 
                max: 62.2, 
                min: 59.3
            }, 
            {
                soc: 213, 
                max: 62.7, 
                min: 61.1
            }, 
            {
                soc: 214, 
                max: 60.3, 
                min: 55.6
            }, 
            {
                soc: 215, 
                max: 62.8, 
                min: 57.6
            }, 
            {
                soc: 216, 
                max: 61.4, 
                min: 57.1
            }, 
            {
                soc: 221, 
                max: 61.0, 
                min: 58.9
            }, 
            {
                soc: 222, 
                max: 68.0, 
                min: 65.3
            }, 
            {
                soc: 223, 
                max: 59.1, 
                min: 57.5
            }, 
            {
                soc: 224, 
                max: 61.3, 
                min: 56.6
            }, 
            {
                soc: 225, 
                max: 56.3, 
                min: 54.2
            }, 
            {
                soc: 231, 
                max: 55.3, 
                min: 54.4
            }, 
            {
                soc: 232, 
                max: 60.3, 
                min: 57.2
            }, 
            {
                soc: 241, 
                max: 62.3, 
                min: 59.6
            }, 
            {
                soc: 242, 
                max: 66.2, 
                min: 63.6
            }, 
            {
                soc: 243, 
                max: 64.3, 
                min: 62.4
            }, 
            {
                soc: 244, 
                max: 60.6, 
                min: 58.2
            }, 
            {
                soc: 245, 
                max: 63.1, 
                min: 59.8
            }, 
            {
                soc: 246, 
                max: 61.8, 
                min: 59.0
            }, 
            {
                soc: 247, 
                max: 61.6, 
                min: 56.3
            }, 
            {
                soc: 248, 
                max: 60.3, 
                min: 56.6
            }, 
            {
                soc: 249, 
                max: 60.5, 
                min: 57.1
            }, 
            {
                soc: 311, 
                max: 55.4, 
                min: 52.6
            }, 
            {
                soc: 312, 
                max: 63.2, 
                min: 57.3
            }, 
            {
                soc: 313, 
                max: 58.6, 
                min: 55.0
            }, 
            {
                soc: 321, 
                max: 60.8, 
                min: 56.4
            }, 
            {
                soc: 322, 
                max: 63.6, 
                min: 61.1
            }, 
            {
                soc: 323, 
                max: 61.0, 
                min: 53.4
            }, 
            {
                soc: 324, 
                max: 60.8, 
                min: 54.5
            }, 
            {
                soc: 331, 
                max: 58.1, 
                min: 56.3
            }, 
            {
                soc: 341, 
                max: 61.5, 
                min: 58.6
            }, 
            {
                soc: 342, 
                max: 61.6, 
                min: 55.3
            }, 
            {
                soc: 343, 
                max: 64.3, 
                min: 58.5
            }, 
            {
                soc: 351, 
                max: 59.8, 
                min: 55.2
            }, 
            {
                soc: 352, 
                max: 61.2, 
                min: 52.9
            }, 
            {
                soc: 353, 
                max: 60.9, 
                min: 58.0
            }, 
            {
                soc: 354, 
                max: 60.7, 
                min: 58.0
            }, 
            {
                soc: 355, 
                max: 58.3, 
                min: 56.8
            }, 
            {
                soc: 356, 
                max: 58.4, 
                min: 53.1
            }, 
            {
                soc: 357, 
                max: 61.8, 
                min: 59.5
            }, 
            {
                soc: 358, 
                max: 66.4, 
                min: 61.6
            }, 
            {
                soc: 411, 
                max: 60.4, 
                min: 57.9
            }, 
            {
                soc: 412, 
                max: 57.3, 
                min: 55.4
            }, 
            {
                soc: 413, 
                max: 53.8, 
                min: 51.1
            }, 
            {
                soc: 414, 
                max: 59.9, 
                min: 57.5
            }, 
            {
                soc: 415, 
                max: 54.3, 
                min: 52.4
            }, 
            {
                soc: 421, 
                max: 55.6, 
                min: 53.1
            }, 
            {
                soc: 511, 
                max: 63.9, 
                min: 58.6
            }, 
            {
                soc: 521, 
                max: 50.6, 
                min: 41.1
            }, 
            {
                soc: 522, 
                max: 53.8, 
                min: 50.3
            }, 
            {
                soc: 523, 
                max: 52.1, 
                min: 47.5
            }, 
            {
                soc: 524, 
                max: 57.3, 
                min: 53.6
            }, 
            {
                soc: 525, 
                max: 60.9, 
                min: 52.1
            }, 
            {
                soc: 531, 
                max: 58.8, 
                min: 54.5
            }, 
            {
                soc: 532, 
                max: 63.1, 
                min: 49.0
            }, 
            {
                soc: 533, 
                max: 59.7, 
                min: 48.5
            }, 
            {
                soc: 541, 
                max: 57.5, 
                min: 44.6
            }, 
            {
                soc: 542, 
                max: 49.9, 
                min: 41.1
            }, 
            {
                soc: 543, 
                max: 51.7, 
                min: 48.5
            }, 
            {
                soc: 544, 
                max: 56.2, 
                min: 46.8
            }, 
            {
                soc: 611, 
                max: 54.5, 
                min: 52.5
            }, 
            {
                soc: 612, 
                max: 65.1, 
                min: 59.3
            }, 
            {
                soc: 613, 
                max: 55.7, 
                min: 53.8
            }, 
            {
                soc: 621, 
                max: 54.5, 
                min: 50.6
            }, 
            {
                soc: 622, 
                max: 63.9, 
                min: 55.4
            }, 
            {
                soc: 623, 
                max: 57.5, 
                min: 48.7
            }, 
            {
                soc: 624, 
                max: 63.2, 
                min: 54.5
            }, 
            {
                soc: 625, 
                max: 80.7, 
                min: 48.1
            }, 
            {
                soc: 631, 
                max: 54.8, 
                min: 45.8
            }, 
            {
                soc: 711, 
                max: 51.4, 
                min: 49.0
            }, 
            {
                soc: 712, 
                max: 58.0, 
                min: 51.3
            }, 
            {
                soc: 713, 
                max: 59.5, 
                min: 53.4
            }, 
            {
                soc: 721, 
                max: 54.6, 
                min: 52.3
            }, 
            {
                soc: 722, 
                max: 58.6, 
                min: 49.5
            }, 
            {
                soc: 811, 
                max: 50.7, 
                min: 45.1
            }, 
            {
                soc: 812, 
                max: 60.9, 
                min: 53.8
            }, 
            {
                soc: 813, 
                max: 56.5, 
                min: 49.4
            }, 
            {
                soc: 814, 
                max: 54.1, 
                min: 49.1
            }, 
            {
                soc: 815, 
                max: 59.9, 
                min: 50.9
            }, 
            {
                soc: 816, 
                max: 58.0, 
                min: 40.6
            }, 
            {
                soc: 821, 
                max: 47.0, 
                min: 43.7
            }, 
            {
                soc: 822, 
                max: 52.8, 
                min: 42.6
            }, 
            {
                soc: 823, 
                max: 56.7, 
                min: 52.4
            }, 
            {
                soc: 911, 
                max: 57.3, 
                min: 49.4
            }, 
            {
                soc: 912, 
                max: 57.3, 
                min: 46.0
            }, 
            {
                soc: 913, 
                max: 41.7, 
                min: 36.4
            }, 
            {
                soc: 921, 
                max: 41.8, 
                min: 37.2
            }, 
            {
                soc: 922, 
                max: 53.4, 
                min: 48.3
            }, 
            {
                soc: 923, 
                max: 42.6, 
                min: 37.3
            }, 
            {
                soc: 924, 
                max: 52.3, 
                min: 38.4
            }, 
            {
                soc: 925, 
                max: 44.9, 
                min: 40.8
            }, 
            {
                soc: 926, 
                max: 53.0, 
                min: 50.3
            }
        ]
    }, 
    {
        id: 7, 
        category: "required-lea", 
        average: {
            max: 70.8, 
            min: 70.5
        }, 
        data: [
            {
                soc: 111, 
                max: 83.5, 
                min: 80.8
            }, 
            {
                soc: 112, 
                max: 77.0, 
                min: 75.9
            }, 
            {
                soc: 113, 
                max: 76.8, 
                min: 75.6
            }, 
            {
                soc: 114, 
                max: 81.6, 
                min: 62.7
            }, 
            {
                soc: 115, 
                max: 73.8, 
                min: 71.0
            }, 
            {
                soc: 116, 
                max: 81.7, 
                min: 78.9
            }, 
            {
                soc: 117, 
                max: 84.2, 
                min: 81.4
            }, 
            {
                soc: 121, 
                max: 84.8, 
                min: 78.6
            }, 
            {
                soc: 122, 
                max: 76.0, 
                min: 73.3
            }, 
            {
                soc: 123, 
                max: 82.5, 
                min: 78.4
            }, 
            {
                soc: 124, 
                max: 74.5, 
                min: 72.3
            }, 
            {
                soc: 125, 
                max: 73.9, 
                min: 71.3
            }, 
            {
                soc: 211, 
                max: 79.5, 
                min: 77.9
            }, 
            {
                soc: 212, 
                max: 78.0, 
                min: 75.9
            }, 
            {
                soc: 213, 
                max: 78.5, 
                min: 77.4
            }, 
            {
                soc: 214, 
                max: 65.4, 
                min: 61.8
            }, 
            {
                soc: 215, 
                max: 81.5, 
                min: 78.3
            }, 
            {
                soc: 216, 
                max: 81.0, 
                min: 78.0
            }, 
            {
                soc: 221, 
                max: 89.0, 
                min: 87.7
            }, 
            {
                soc: 222, 
                max: 84.2, 
                min: 82.5
            }, 
            {
                soc: 223, 
                max: 87.2, 
                min: 86.2
            }, 
            {
                soc: 224, 
                max: 91.0, 
                min: 88.9
            }, 
            {
                soc: 225, 
                max: 85.7, 
                min: 84.4
            }, 
            {
                soc: 231, 
                max: 80.2, 
                min: 79.6
            }, 
            {
                soc: 232, 
                max: 82.3, 
                min: 80.1
            }, 
            {
                soc: 241, 
                max: 81.6, 
                min: 80.0
            }, 
            {
                soc: 242, 
                max: 79.5, 
                min: 77.5
            }, 
            {
                soc: 243, 
                max: 77.8, 
                min: 76.4
            }, 
            {
                soc: 244, 
                max: 72.6, 
                min: 70.9
            }, 
            {
                soc: 245, 
                max: 77.7, 
                min: 75.3
            }, 
            {
                soc: 246, 
                max: 83.5, 
                min: 81.9
            }, 
            {
                soc: 247, 
                max: 73.9, 
                min: 69.9
            }, 
            {
                soc: 248, 
                max: 77.3, 
                min: 74.7
            }, 
            {
                soc: 249, 
                max: 69.4, 
                min: 67.0
            }, 
            {
                soc: 311, 
                max: 71.1, 
                min: 69.0
            }, 
            {
                soc: 312, 
                max: 76.8, 
                min: 72.2
            }, 
            {
                soc: 313, 
                max: 75.1, 
                min: 72.5
            }, 
            {
                soc: 321, 
                max: 80.3, 
                min: 77.3
            }, 
            {
                soc: 322, 
                max: 70.6, 
                min: 68.8
            }, 
            {
                soc: 323, 
                max: 77.7, 
                min: 71.9
            }, 
            {
                soc: 324, 
                max: 89.6, 
                min: 86.1
            }, 
            {
                soc: 331, 
                max: 79.3, 
                min: 78.1
            }, 
            {
                soc: 341, 
                max: 72.1, 
                min: 70.0
            }, 
            {
                soc: 342, 
                max: 71.9, 
                min: 66.7
            }, 
            {
                soc: 343, 
                max: 76.0, 
                min: 72.0
            }, 
            {
                soc: 351, 
                max: 83.9, 
                min: 81.2
            }, 
            {
                soc: 352, 
                max: 74.2, 
                min: 68.3
            }, 
            {
                soc: 353, 
                max: 73.6, 
                min: 71.5
            }, 
            {
                soc: 354, 
                max: 71.2, 
                min: 69.1
            }, 
            {
                soc: 355, 
                max: 67.8, 
                min: 66.7
            }, 
            {
                soc: 356, 
                max: 71.7, 
                min: 67.9
            }, 
            {
                soc: 357, 
                max: 74.4, 
                min: 72.7
            }, 
            {
                soc: 358, 
                max: 81.9, 
                min: 78.7
            }, 
            {
                soc: 411, 
                max: 73.1, 
                min: 71.3
            }, 
            {
                soc: 412, 
                max: 66.3, 
                min: 64.8
            }, 
            {
                soc: 413, 
                max: 63.3, 
                min: 61.1
            }, 
            {
                soc: 414, 
                max: 73.0, 
                min: 71.3
            }, 
            {
                soc: 415, 
                max: 58.6, 
                min: 57.1
            }, 
            {
                soc: 421, 
                max: 60.3, 
                min: 58.4
            }, 
            {
                soc: 511, 
                max: 68.4, 
                min: 64.6
            }, 
            {
                soc: 521, 
                max: 62.3, 
                min: 55.0
            }, 
            {
                soc: 522, 
                max: 69.1, 
                min: 66.1
            }, 
            {
                soc: 523, 
                max: 76.4, 
                min: 73.0
            }, 
            {
                soc: 524, 
                max: 75.9, 
                min: 73.3
            }, 
            {
                soc: 525, 
                max: 83.1, 
                min: 77.6
            }, 
            {
                soc: 531, 
                max: 71.5, 
                min: 68.3
            }, 
            {
                soc: 532, 
                max: 70.8, 
                min: 60.4
            }, 
            {
                soc: 533, 
                max: 73.9, 
                min: 66.6
            }, 
            {
                soc: 541, 
                max: 71.4, 
                min: 61.5
            }, 
            {
                soc: 542, 
                max: 64.2, 
                min: 57.7
            }, 
            {
                soc: 543, 
                max: 71.7, 
                min: 69.1
            }, 
            {
                soc: 544, 
                max: 66.8, 
                min: 59.1
            }, 
            {
                soc: 611, 
                max: 69.7, 
                min: 68.1
            }, 
            {
                soc: 612, 
                max: 69.5, 
                min: 64.9
            }, 
            {
                soc: 613, 
                max: 73.5, 
                min: 72.1
            }, 
            {
                soc: 621, 
                max: 69.0, 
                min: 65.9
            }, 
            {
                soc: 622, 
                max: 76.8, 
                min: 70.3
            }, 
            {
                soc: 623, 
                max: 60.1, 
                min: 53.4
            }, 
            {
                soc: 624, 
                max: 62.8, 
                min: 55.4
            }, 
            {
                soc: 625, 
                max: 67.8, 
                min: 41.8
            }, 
            {
                soc: 631, 
                max: 68.8, 
                min: 61.7
            }, 
            {
                soc: 711, 
                max: 59.5, 
                min: 57.4
            }, 
            {
                soc: 712, 
                max: 65.4, 
                min: 60.0
            }, 
            {
                soc: 713, 
                max: 71.9, 
                min: 67.9
            }, 
            {
                soc: 721, 
                max: 64.1, 
                min: 62.2
            }, 
            {
                soc: 722, 
                max: 77.1, 
                min: 71.5
            }, 
            {
                soc: 811, 
                max: 60.7, 
                min: 55.4
            }, 
            {
                soc: 812, 
                max: 77.6, 
                min: 72.9
            }, 
            {
                soc: 813, 
                max: 62.4, 
                min: 56.3
            }, 
            {
                soc: 814, 
                max: 66.1, 
                min: 62.2
            }, 
            {
                soc: 815, 
                max: 64.9, 
                min: 56.9
            }, 
            {
                soc: 816, 
                max: 66.9, 
                min: 51.5
            }, 
            {
                soc: 821, 
                max: 50.7, 
                min: 48.0
            }, 
            {
                soc: 822, 
                max: 59.0, 
                min: 51.2
            }, 
            {
                soc: 823, 
                max: 66.1, 
                min: 62.4
            }, 
            {
                soc: 911, 
                max: 65.7, 
                min: 58.8
            }, 
            {
                soc: 912, 
                max: 68.7, 
                min: 59.2
            }, 
            {
                soc: 913, 
                max: 52.7, 
                min: 47.3
            }, 
            {
                soc: 921, 
                max: 47.6, 
                min: 43.6
            }, 
            {
                soc: 922, 
                max: 46.1, 
                min: 41.9
            }, 
            {
                soc: 923, 
                max: 58.5, 
                min: 53.7
            }, 
            {
                soc: 924, 
                max: 53.3, 
                min: 42.1
            }, 
            {
                soc: 925, 
                max: 50.2, 
                min: 46.5
            }, 
            {
                soc: 926, 
                max: 57.9, 
                min: 55.6
            }
        ]
    }, 
    {
        id: 8, 
        category: "promotion-pro", 
        average: {
            max: 42.7, 
            min: 42.3
        }, 
        data: [
            {
                soc: 111, 
                max: 49.6, 
                min: 44.5
            }, 
            {
                soc: 112, 
                max: 48.8, 
                min: 46.9
            }, 
            {
                soc: 113, 
                max: 51.8, 
                min: 49.9
            }, 
            {
                soc: 114, 
                max: 68.2, 
                min: 31.9
            }, 
            {
                soc: 115, 
                max: 48.3, 
                min: 44.2
            }, 
            {
                soc: 116, 
                max: 65.3, 
                min: 60.6
            }, 
            {
                soc: 117, 
                max: 51.7, 
                min: 46.6
            }, 
            {
                soc: 121, 
                max: 44.7, 
                min: 34.6
            }, 
            {
                soc: 122, 
                max: 46.1, 
                min: 41.5
            }, 
            {
                soc: 123, 
                max: 48.9, 
                min: 42.4
            }, 
            {
                soc: 124, 
                max: 46.3, 
                min: 42.9
            }, 
            {
                soc: 125, 
                max: 47.0, 
                min: 42.9
            }, 
            {
                soc: 211, 
                max: 52.0, 
                min: 49.3
            }, 
            {
                soc: 212, 
                max: 55.9, 
                min: 52.4
            }, 
            {
                soc: 213, 
                max: 54.6, 
                min: 52.8
            }, 
            {
                soc: 214, 
                max: 39.0, 
                min: 34.2
            }, 
            {
                soc: 215, 
                max: 62.4, 
                min: 56.0
            }, 
            {
                soc: 216, 
                max: 50.6, 
                min: 45.8
            }, 
            {
                soc: 221, 
                max: 65.2, 
                min: 62.4
            }, 
            {
                soc: 222, 
                max: 46.7, 
                min: 43.6
            }, 
            {
                soc: 223, 
                max: 44.0, 
                min: 42.3
            }, 
            {
                soc: 224, 
                max: 44.3, 
                min: 39.1
            }, 
            {
                soc: 225, 
                max: 41.7, 
                min: 39.4
            }, 
            {
                soc: 231, 
                max: 41.7, 
                min: 40.8
            }, 
            {
                soc: 232, 
                max: 40.5, 
                min: 36.9
            }, 
            {
                soc: 241, 
                max: 57.9, 
                min: 54.8
            }, 
            {
                soc: 242, 
                max: 60.9, 
                min: 57.4
            }, 
            {
                soc: 243, 
                max: 59.1, 
                min: 56.9
            }, 
            {
                soc: 244, 
                max: 51.3, 
                min: 48.6
            }, 
            {
                soc: 245, 
                max: 56.4, 
                min: 52.6
            }, 
            {
                soc: 246, 
                max: 45.1, 
                min: 42.1
            }, 
            {
                soc: 247, 
                max: 32.6, 
                min: 27.6
            }, 
            {
                soc: 248, 
                max: 49.8, 
                min: 45.7
            }, 
            {
                soc: 249, 
                max: 48.7, 
                min: 45.0
            }, 
            {
                soc: 311, 
                max: 40.4, 
                min: 37.4
            }, 
            {
                soc: 312, 
                max: 51.7, 
                min: 44.6
            }, 
            {
                soc: 313, 
                max: 44.5, 
                min: 40.8
            }, 
            {
                soc: 321, 
                max: 36.7, 
                min: 31.8
            }, 
            {
                soc: 322, 
                max: 40.0, 
                min: 37.4
            }, 
            {
                soc: 323, 
                max: 38.4, 
                min: 29.9
            }, 
            {
                soc: 324, 
                max: 32.7, 
                min: 27.0
            }, 
            {
                soc: 331, 
                max: 55.1, 
                min: 53.3
            }, 
            {
                soc: 341, 
                max: 46.9, 
                min: 43.6
            }, 
            {
                soc: 342, 
                max: 53.6, 
                min: 46.5
            }, 
            {
                soc: 343, 
                max: 46.1, 
                min: 39.5
            }, 
            {
                soc: 351, 
                max: 65.9, 
                min: 60.6
            }, 
            {
                soc: 352, 
                max: 46.5, 
                min: 38.0
            }, 
            {
                soc: 353, 
                max: 52.0, 
                min: 48.6
            }, 
            {
                soc: 354, 
                max: 50.6, 
                min: 47.5
            }, 
            {
                soc: 355, 
                max: 49.8, 
                min: 48.1
            }, 
            {
                soc: 356, 
                max: 47.9, 
                min: 42.2
            }, 
            {
                soc: 357, 
                max: 48.5, 
                min: 46.0
            }, 
            {
                soc: 358, 
                max: 48.1, 
                min: 43.0
            }, 
            {
                soc: 411, 
                max: 47.2, 
                min: 44.5
            }, 
            {
                soc: 412, 
                max: 40.4, 
                min: 38.3
            }, 
            {
                soc: 413, 
                max: 37.5, 
                min: 34.7
            }, 
            {
                soc: 414, 
                max: 42.7, 
                min: 40.0
            }, 
            {
                soc: 415, 
                max: 32.1, 
                min: 30.2
            }, 
            {
                soc: 421, 
                max: 31.2, 
                min: 28.8
            }, 
            {
                soc: 511, 
                max: 41.4, 
                min: 35.5
            }, 
            {
                soc: 521, 
                max: 31.2, 
                min: 22.3
            }, 
            {
                soc: 522, 
                max: 36.4, 
                min: 32.4
            }, 
            {
                soc: 523, 
                max: 36.4, 
                min: 31.4
            }, 
            {
                soc: 524, 
                max: 40.8, 
                min: 36.8
            }, 
            {
                soc: 525, 
                max: 47.1, 
                min: 37.2
            }, 
            {
                soc: 531, 
                max: 40.5, 
                min: 35.5
            }, 
            {
                soc: 532, 
                max: 42.1, 
                min: 25.7
            }, 
            {
                soc: 533, 
                max: 43.4, 
                min: 32.7
            }, 
            {
                soc: 541, 
                max: 36.6, 
                min: 22.9
            }, 
            {
                soc: 542, 
                max: 26.6, 
                min: 18.5
            }, 
            {
                soc: 543, 
                max: 39.9, 
                min: 36.2
            }, 
            {
                soc: 544, 
                max: 38.4, 
                min: 28.4
            }, 
            {
                soc: 611, 
                max: 27.4, 
                min: 25.4
            }, 
            {
                soc: 612, 
                max: 43.9, 
                min: 37.6
            }, 
            {
                soc: 613, 
                max: 34.6, 
                min: 32.7
            }, 
            {
                soc: 621, 
                max: 43.9, 
                min: 39.8
            }, 
            {
                soc: 622, 
                max: 45.3, 
                min: 35.5
            }, 
            {
                soc: 623, 
                max: 30.4, 
                min: 22.7
            }, 
            {
                soc: 624, 
                max: 42.0, 
                min: 32.1
            }, 
            {
                soc: 625, 
                max: 53.6, 
                min: 12.9
            }, 
            {
                soc: 631, 
                max: 30.4, 
                min: 21.4
            }, 
            {
                soc: 711, 
                max: 33.5, 
                min: 31.0
            }, 
            {
                soc: 712, 
                max: 42.0, 
                min: 35.2
            }, 
            {
                soc: 713, 
                max: 53.2, 
                min: 47.1
            }, 
            {
                soc: 721, 
                max: 37.9, 
                min: 35.5
            }, 
            {
                soc: 722, 
                max: 45.7, 
                min: 37.4
            }, 
            {
                soc: 811, 
                max: 39.4, 
                min: 32.8
            }, 
            {
                soc: 812, 
                max: 54.6, 
                min: 46.6
            }, 
            {
                soc: 813, 
                max: 37.2, 
                min: 30.0
            }, 
            {
                soc: 814, 
                max: 42.5, 
                min: 37.0
            }, 
            {
                soc: 815, 
                max: 38.6, 
                min: 28.4
            }, 
            {
                soc: 816, 
                max: 47.4, 
                min: 29.9
            }, 
            {
                soc: 821, 
                max: 23.6, 
                min: 20.8
            }, 
            {
                soc: 822, 
                max: 36.3, 
                min: 26.3
            }, 
            {
                soc: 823, 
                max: 45.9, 
                min: 41.6
            }, 
            {
                soc: 911, 
                max: 50.1, 
                min: 40.5
            }, 
            {
                soc: 912, 
                max: 43.9, 
                min: 31.7
            }, 
            {
                soc: 913, 
                max: 25.5, 
                min: 20.5
            }, 
            {
                soc: 921, 
                max: 27.0, 
                min: 22.4
            }, 
            {
                soc: 922, 
                max: 28.6, 
                min: 23.7
            }, 
            {
                soc: 923, 
                max: 31.4, 
                min: 26.0
            }, 
            {
                soc: 924, 
                max: 37.1, 
                min: 22.0
            }, 
            {
                soc: 925, 
                max: 31.9, 
                min: 27.9
            }, 
            {
                soc: 926, 
                max: 41.7, 
                min: 38.6
            }
        ]
    }, 
    {
        id: 9, 
        category: "job-ins", 
        average: {
            max: 87.2, 
            min: 86.9
        }, 
        data: [
            {
                soc: 111, 
                max: 88.9, 
                min: 85.8
            }, 
            {
                soc: 112, 
                max: 86.4, 
                min: 85.0
            }, 
            {
                soc: 113, 
                max: 85.5, 
                min: 84.0
            }, 
            {
                soc: 114, 
                max: 98.2, 
                min: 67.0
            }, 
            {
                soc: 115, 
                max: 84.2, 
                min: 80.6
            }, 
            {
                soc: 116, 
                max: 95.1, 
                min: 92.6
            }, 
            {
                soc: 117, 
                max: 91.9, 
                min: 88.1
            }, 
            {
                soc: 121, 
                max: 94.8, 
                min: 88.3
            }, 
            {
                soc: 122, 
                max: 88.8, 
                min: 85.3
            }, 
            {
                soc: 123, 
                max: 93.5, 
                min: 89.3
            }, 
            {
                soc: 124, 
                max: 88.5, 
                min: 85.8
            }, 
            {
                soc: 125, 
                max: 90.2, 
                min: 87.3
            }, 
            {
                soc: 211, 
                max: 89.6, 
                min: 87.7
            }, 
            {
                soc: 212, 
                max: 89.8, 
                min: 87.3
            }, 
            {
                soc: 213, 
                max: 88.9, 
                min: 87.6
            }, 
            {
                soc: 214, 
                max: 86.6, 
                min: 82.3
            }, 
            {
                soc: 215, 
                max: 91.5, 
                min: 87.4
            }, 
            {
                soc: 216, 
                max: 83.9, 
                min: 79.3
            }, 
            {
                soc: 221, 
                max: 95.3, 
                min: 94.0
            }, 
            {
                soc: 222, 
                max: 95.9, 
                min: 94.3
            }, 
            {
                soc: 223, 
                max: 96.0, 
                min: 95.1
            }, 
            {
                soc: 224, 
                max: 98.7, 
                min: 96.9
            }, 
            {
                soc: 225, 
                max: 96.3, 
                min: 95.2
            }, 
            {
                soc: 231, 
                max: 92.4, 
                min: 91.7
            }, 
            {
                soc: 232, 
                max: 90.9, 
                min: 88.4
            }, 
            {
                soc: 241, 
                max: 92.2, 
                min: 90.2
            }, 
            {
                soc: 242, 
                max: 91.7, 
                min: 89.6
            }, 
            {
                soc: 243, 
                max: 85.8, 
                min: 83.9
            }, 
            {
                soc: 244, 
                max: 85.0, 
                min: 82.6
            }, 
            {
                soc: 245, 
                max: 89.7, 
                min: 86.9
            }, 
            {
                soc: 246, 
                max: 95.4, 
                min: 93.8
            }, 
            {
                soc: 247, 
                max: 88.8, 
                min: 83.7
            }, 
            {
                soc: 248, 
                max: 89.5, 
                min: 86.2
            }, 
            {
                soc: 249, 
                max: 82.5, 
                min: 79.3
            }, 
            {
                soc: 311, 
                max: 89.4, 
                min: 87.1
            }, 
            {
                soc: 312, 
                max: 89.6, 
                min: 84.3
            }, 
            {
                soc: 313, 
                max: 87.2, 
                min: 84.1
            }, 
            {
                soc: 321, 
                max: 92.6, 
                min: 89.1
            }, 
            {
                soc: 322, 
                max: 86.1, 
                min: 83.8
            }, 
            {
                soc: 323, 
                max: 93.7, 
                min: 86.6
            }, 
            {
                soc: 324, 
                max: 98.7, 
                min: 95.6
            }, 
            {
                soc: 331, 
                max: 95.5, 
                min: 94.5
            }, 
            {
                soc: 341, 
                max: 81.7, 
                min: 78.9
            }, 
            {
                soc: 342, 
                max: 87.9, 
                min: 82.3
            }, 
            {
                soc: 343, 
                max: 88.3, 
                min: 83.7
            }, 
            {
                soc: 351, 
                max: 88.8, 
                min: 85.2
            }, 
            {
                soc: 352, 
                max: 89.8, 
                min: 83.1
            }, 
            {
                soc: 353, 
                max: 89.1, 
                min: 86.5
            }, 
            {
                soc: 354, 
                max: 87.7, 
                min: 85.2
            }, 
            {
                soc: 355, 
                max: 84.3, 
                min: 82.8
            }, 
            {
                soc: 356, 
                max: 91.9, 
                min: 87.8
            }, 
            {
                soc: 357, 
                max: 84.6, 
                min: 82.4
            }, 
            {
                soc: 358, 
                max: 91.7, 
                min: 88.2
            }, 
            {
                soc: 411, 
                max: 90.8, 
                min: 88.8
            }, 
            {
                soc: 412, 
                max: 87.3, 
                min: 85.6
            }, 
            {
                soc: 413, 
                max: 86.3, 
                min: 83.8
            }, 
            {
                soc: 414, 
                max: 88.1, 
                min: 86.0
            }, 
            {
                soc: 415, 
                max: 85.8, 
                min: 84.1
            }, 
            {
                soc: 421, 
                max: 89.2, 
                min: 87.1
            }, 
            {
                soc: 511, 
                max: 94.0, 
                min: 90.6
            }, 
            {
                soc: 521, 
                max: 82.7, 
                min: 73.8
            }, 
            {
                soc: 522, 
                max: 88.1, 
                min: 85.0
            }, 
            {
                soc: 523, 
                max: 88.6, 
                min: 84.7
            }, 
            {
                soc: 524, 
                max: 89.8, 
                min: 86.9
            }, 
            {
                soc: 525, 
                max: 90.8, 
                min: 82.9
            }, 
            {
                soc: 531, 
                max: 87.2, 
                min: 83.2
            }, 
            {
                soc: 532, 
                max: 90.3, 
                min: 78.1
            }, 
            {
                soc: 533, 
                max: 91.2, 
                min: 81.3
            }, 
            {
                soc: 541, 
                max: 87.6, 
                min: 74.0
            }, 
            {
                soc: 542, 
                max: 86.7, 
                min: 77.4
            }, 
            {
                soc: 543, 
                max: 86.5, 
                min: 83.6
            }, 
            {
                soc: 544, 
                max: 87.3, 
                min: 79.4
            }, 
            {
                soc: 611, 
                max: 87.6, 
                min: 85.9
            }, 
            {
                soc: 612, 
                max: 91.1, 
                min: 86.7
            }, 
            {
                soc: 613, 
                max: 90.1, 
                min: 88.7
            }, 
            {
                soc: 621, 
                max: 85.9, 
                min: 82.3
            }, 
            {
                soc: 622, 
                max: 92.5, 
                min: 85.6
            }, 
            {
                soc: 623, 
                max: 88.4, 
                min: 80.7
            }, 
            {
                soc: 624, 
                max: 89.8, 
                min: 82.0
            }, 
            {
                soc: 625, 
                max: 105.6, 
                min: 81.3
            }, 
            {
                soc: 631, 
                max: 93.5, 
                min: 84.7
            }, 
            {
                soc: 711, 
                max: 84.0, 
                min: 81.8
            }, 
            {
                soc: 712, 
                max: 85.9, 
                min: 80.5
            }, 
            {
                soc: 713, 
                max: 86.0, 
                min: 80.6
            }, 
            {
                soc: 721, 
                max: 84.8, 
                min: 82.5
            }, 
            {
                soc: 722, 
                max: 88.3, 
                min: 80.5
            }, 
            {
                soc: 811, 
                max: 85.0, 
                min: 79.3
            }, 
            {
                soc: 812, 
                max: 91.8, 
                min: 86.4
            }, 
            {
                soc: 813, 
                max: 90.2, 
                min: 83.8
            }, 
            {
                soc: 814, 
                max: 86.8, 
                min: 82.6
            }, 
            {
                soc: 815, 
                max: 83.7, 
                min: 74.4
            }, 
            {
                soc: 816, 
                max: 94.6, 
                min: 80.9
            }, 
            {
                soc: 821, 
                max: 86.7, 
                min: 84.0
            }, 
            {
                soc: 822, 
                max: 88.1, 
                min: 79.5
            }, 
            {
                soc: 823, 
                max: 93.9, 
                min: 90.9
            }, 
            {
                soc: 911, 
                max: 91.8, 
                min: 85.5
            }, 
            {
                soc: 912, 
                max: 83.4, 
                min: 71.4
            }, 
            {
                soc: 913, 
                max: 82.2, 
                min: 76.3
            }, 
            {
                soc: 921, 
                max: 90.5, 
                min: 86.5
            }, 
            {
                soc: 922, 
                max: 88.3, 
                min: 84.2
            }, 
            {
                soc: 923, 
                max: 86.7, 
                min: 81.6
            }, 
            {
                soc: 924, 
                max: 93.8, 
                min: 82.9
            }, 
            {
                soc: 925, 
                max: 82.8, 
                min: 78.6
            }, 
            {
                soc: 926, 
                max: 85.2, 
                min: 82.7
            }
        ]
    }, 
    {
        id: 10, 
        category: "pay", 
        average: {
            max: 57.2, 
            min: 56.9
        }, 
        data: [
            {
                soc: 111, 
                max: 86.2, 
                min: 82.8
            }, 
            {
                soc: 112, 
                max: 76.0, 
                min: 74.7
            }, 
            {
                soc: 113, 
                max: 86.1, 
                min: 84.9
            }, 
            {
                soc: 114, 
                max: 93.0, 
                min: 59.1
            }, 
            {
                soc: 115, 
                max: 47.1, 
                min: 44.6
            }, 
            {
                soc: 116, 
                max: 78.9, 
                min: 76.1
            }, 
            {
                soc: 117, 
                max: 76.1, 
                min: 72.6
            }, 
            {
                soc: 121, 
                max: 53.7, 
                min: 47.7
            }, 
            {
                soc: 122, 
                max: 47.4, 
                min: 44.5
            }, 
            {
                soc: 123, 
                max: 59.3, 
                min: 55.4
            }, 
            {
                soc: 124, 
                max: 61.4, 
                min: 59.1
            }, 
            {
                soc: 125, 
                max: 64.1, 
                min: 61.3
            }, 
            {
                soc: 211, 
                max: 65.4, 
                min: 63.5
            }, 
            {
                soc: 212, 
                max: 75.2, 
                min: 73.0
            }, 
            {
                soc: 213, 
                max: 76.5, 
                min: 75.2
            }, 
            {
                soc: 214, 
                max: 51.7, 
                min: 48.5
            }, 
            {
                soc: 215, 
                max: 63.7, 
                min: 59.7
            }, 
            {
                soc: 216, 
                max: 73.8, 
                min: 70.6
            }, 
            {
                soc: 221, 
                max: 85.2, 
                min: 83.6
            }, 
            {
                soc: 222, 
                max: 67.0, 
                min: 65.1
            }, 
            {
                soc: 223, 
                max: 59.7, 
                min: 58.8
            }, 
            {
                soc: 224, 
                max: 74.6, 
                min: 71.6
            }, 
            {
                soc: 225, 
                max: 72.5, 
                min: 71.2
            }, 
            {
                soc: 231, 
                max: 68.3, 
                min: 67.7
            }, 
            {
                soc: 232, 
                max: 76.1, 
                min: 73.4
            }, 
            {
                soc: 241, 
                max: 81.7, 
                min: 79.5
            }, 
            {
                soc: 242, 
                max: 76.9, 
                min: 74.5
            }, 
            {
                soc: 243, 
                max: 75.6, 
                min: 74.0
            }, 
            {
                soc: 244, 
                max: 79.4, 
                min: 77.8
            }, 
            {
                soc: 245, 
                max: 73.8, 
                min: 71.4
            }, 
            {
                soc: 246, 
                max: 60.5, 
                min: 58.8
            }, 
            {
                soc: 247, 
                max: 58.2, 
                min: 54.7
            }, 
            {
                soc: 248, 
                max: 74.0, 
                min: 71.4
            }, 
            {
                soc: 249, 
                max: 66.6, 
                min: 64.0
            }, 
            {
                soc: 311, 
                max: 56.9, 
                min: 54.9
            }, 
            {
                soc: 312, 
                max: 63.5, 
                min: 59.0
            }, 
            {
                soc: 313, 
                max: 59.6, 
                min: 56.9
            }, 
            {
                soc: 321, 
                max: 53.4, 
                min: 49.7
            }, 
            {
                soc: 322, 
                max: 46.7, 
                min: 45.1
            }, 
            {
                soc: 323, 
                max: 29.3, 
                min: 23.7
            }, 
            {
                soc: 324, 
                max: 40.9, 
                min: 38.4
            }, 
            {
                soc: 331, 
                max: 60.3, 
                min: 59.1
            }, 
            {
                soc: 341, 
                max: 64.6, 
                min: 62.0
            }, 
            {
                soc: 342, 
                max: 61.0, 
                min: 56.2
            }, 
            {
                soc: 343, 
                max: 47.4, 
                min: 42.6
            }, 
            {
                soc: 351, 
                max: 90.4, 
                min: 87.6
            }, 
            {
                soc: 352, 
                max: 55.9, 
                min: 49.3
            }, 
            {
                soc: 353, 
                max: 75.2, 
                min: 72.7
            }, 
            {
                soc: 354, 
                max: 62.8, 
                min: 60.6
            }, 
            {
                soc: 355, 
                max: 66.2, 
                min: 64.9
            }, 
            {
                soc: 356, 
                max: 53.5, 
                min: 49.2
            }, 
            {
                soc: 357, 
                max: 60.0, 
                min: 58.3
            }, 
            {
                soc: 358, 
                max: 72.4, 
                min: 68.9
            }, 
            {
                soc: 411, 
                max: 61.3, 
                min: 59.3
            }, 
            {
                soc: 412, 
                max: 50.3, 
                min: 48.7
            }, 
            {
                soc: 413, 
                max: 43.3, 
                min: 41.6
            }, 
            {
                soc: 414, 
                max: 58.4, 
                min: 56.6
            }, 
            {
                soc: 415, 
                max: 36.4, 
                min: 35.5
            }, 
            {
                soc: 421, 
                max: 40.4, 
                min: 38.7
            }, 
            {
                soc: 511, 
                max: 41.1, 
                min: 37.7
            }, 
            {
                soc: 521, 
                max: 49.8, 
                min: 43.7
            }, 
            {
                soc: 522, 
                max: 58.0, 
                min: 55.4
            }, 
            {
                soc: 523, 
                max: 57.6, 
                min: 54.5
            }, 
            {
                soc: 524, 
                max: 61.8, 
                min: 59.3
            }, 
            {
                soc: 525, 
                max: 65.1, 
                min: 59.0
            }, 
            {
                soc: 531, 
                max: 61.3, 
                min: 58.2
            }, 
            {
                soc: 532, 
                max: 64.8, 
                min: 55.3
            }, 
            {
                soc: 533, 
                max: 66.1, 
                min: 58.9
            }, 
            {
                soc: 541, 
                max: 37.6, 
                min: 29.1
            }, 
            {
                soc: 542, 
                max: 49.5, 
                min: 43.2
            }, 
            {
                soc: 543, 
                max: 35.8, 
                min: 33.9
            }, 
            {
                soc: 544, 
                max: 46.9, 
                min: 39.4
            }, 
            {
                soc: 611, 
                max: 27.7, 
                min: 26.5
            }, 
            {
                soc: 612, 
                max: 34.6, 
                min: 30.7
            }, 
            {
                soc: 613, 
                max: 31.1, 
                min: 30.0
            }, 
            {
                soc: 621, 
                max: 42.7, 
                min: 40.0
            }, 
            {
                soc: 622, 
                max: 34.6, 
                min: 28.6
            }, 
            {
                soc: 623, 
                max: 36.0, 
                min: 30.8
            }, 
            {
                soc: 624, 
                max: 34.0, 
                min: 28.5
            }, 
            {
                soc: 625, 
                max: 45.0, 
                min: 19.1
            }, 
            {
                soc: 631, 
                max: 40.5, 
                min: 35.9
            }, 
            {
                soc: 711, 
                max: 26.9, 
                min: 25.5
            }, 
            {
                soc: 712, 
                max: 45.6, 
                min: 40.7
            }, 
            {
                soc: 713, 
                max: 43.4, 
                min: 38.5
            }, 
            {
                soc: 721, 
                max: 35.0, 
                min: 33.7
            }, 
            {
                soc: 722, 
                max: 53.1, 
                min: 46.7
            }, 
            {
                soc: 811, 
                max: 47.9, 
                min: 42.7
            }, 
            {
                soc: 812, 
                max: 70.6, 
                min: 65.0
            }, 
            {
                soc: 813, 
                max: 43.4, 
                min: 37.8
            }, 
            {
                soc: 814, 
                max: 51.9, 
                min: 48.0
            }, 
            {
                soc: 815, 
                max: 49.5, 
                min: 42.2
            }, 
            {
                soc: 816, 
                max: 62.6, 
                min: 53.1
            }, 
            {
                soc: 821, 
                max: 41.3, 
                min: 39.3
            }, 
            {
                soc: 822, 
                max: 48.5, 
                min: 43.1
            }, 
            {
                soc: 823, 
                max: 67.6, 
                min: 63.7
            }, 
            {
                soc: 911, 
                max: 33.4, 
                min: 27.9
            }, 
            {
                soc: 912, 
                max: 47.7, 
                min: 39.4
            }, 
            {
                soc: 913, 
                max: 37.2, 
                min: 33.7
            }, 
            {
                soc: 921, 
                max: 37.9, 
                min: 36.1
            }, 
            {
                soc: 922, 
                max: 26.4, 
                min: 23.4
            }, 
            {
                soc: 923, 
                max: 34.6, 
                min: 31.5
            }, 
            {
                soc: 924, 
                max: 27.3, 
                min: 20.8
            }, 
            {
                soc: 925, 
                max: 31.8, 
                min: 29.8
            }, 
            {
                soc: 926, 
                max: 21.7, 
                min: 20.4
            }
        ]
    }
];



// WEBPACK FOOTER //
// ./src/Results/comparison.js